"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _formik = require("formik");
var _data = require("./data.config");
var _TextInput = _interopRequireDefault(require("./Common/TextInput"));
var _CheckboxGroup = require("./Content/CheckboxGroup");
var _TextArea = _interopRequireDefault(require("./Common/TextArea"));
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _RequestToCorrectContent = _interopRequireDefault(require("./Content/RequestToCorrectContent"));
var _Popup = _interopRequireDefault(require("./Common/Popup"));
var _AddressCorrection = _interopRequireDefault(require("./Content/AddressCorrection"));
var _CustomAddress = _interopRequireDefault(require("./Content/CustomAddress"));
var _Timeout = _interopRequireDefault(require("./Content/Timeout"));
var _Questions = _interopRequireDefault(require("./Content/Questions"));
var _axios = _interopRequireDefault(require("axios"));
var _helper = require("./helper");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 *  A react component to create the CCPA form
 *
 * @param {object} props The properties passed into the object
 *
 * @returns {React.ReactElement} A CCPA Form
 */
function CCPAForm(props) {
  /* istanbul ignore next */
  if (!props.rendering.fields) return null;
  var extractFields = (0, _utils.extractFieldsFn)(props);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    id: "ccpaForm"
  }, /*#__PURE__*/_react.default.createElement(FormContent, {
    extractFields: extractFields
  })));
}
var FormContent = _ref => {
  var {
    extractFields
  } = _ref;
  var [showCorrectionModal, setShowCorrectionModal] = (0, _react.useState)(false);
  var [showCustomAddressModal, setShowCustomAddressModal] = (0, _react.useState)(false);
  var [showTimeoutModal, setShowTimeoutModal] = (0, _react.useState)(false);
  var [showQuestionsModal, setShowQuestionsModal] = (0, _react.useState)(false);
  var [showErrorAlert, setShowErrorAlert] = (0, _react.useState)(false);
  var [isLoading, setIsLoading] = (0, _react.useState)(false);
  var [timeoutId, setTimeoutId] = (0, _react.useState)('');
  var handleSubmit = (values, bag) => {
    function submitAddressValidation(_x) {
      return _submitAddressValidation.apply(this, arguments);
    }
    function _submitAddressValidation() {
      _submitAddressValidation = _asyncToGenerator(function* (values) {
        var response = yield _axios.default.post('/apicalls/ccpa/verifyaddress', {
          'street': values.residentialAddress,
          'city': values.city,
          'state': values.state,
          'zip': values.zipCode
        });
        bag.setFieldValue('addressResponse', response.data);
      });
      return _submitAddressValidation.apply(this, arguments);
    }
    ;
    setIsLoading(true);
    submitAddressValidation(values);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 12,
    lg: 7
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: _data.initialValuesConfig,
    validationSchema: _data.validationConfig,
    onSubmit: handleSubmit
  }, formik => {
    var _formik$values3, _formik$values4, _formik$values5, _formik$values6;
    // Handle address verification and various scenarios
    (0, _react.useEffect)(() => {
      var {
        addressResponse
      } = formik.values;
      if (addressResponse) {
        var _addressResponse$Veri, _addressResponse$Veri2, _addressResponse$Veri3, _addressResponse$Veri4;
        var resultsMatch = (0, _helper.compareAddress)(formik.values);
        // Show two modals in case of user interaction, if 'Verified' and resultsMatch we will not trigger either pop up
        if ((addressResponse === null || addressResponse === void 0 || (_addressResponse$Veri = addressResponse.VerificationFlags) === null || _addressResponse$Veri === void 0 ? void 0 : _addressResponse$Veri.VerifyLevel) === 'Verified' && !resultsMatch || (addressResponse === null || addressResponse === void 0 || (_addressResponse$Veri2 = addressResponse.VerificationFlags) === null || _addressResponse$Veri2 === void 0 ? void 0 : _addressResponse$Veri2.VerifyLevel) === 'InteractionRequired') {
          setShowCorrectionModal(true);
        } else if ((addressResponse === null || addressResponse === void 0 || (_addressResponse$Veri3 = addressResponse.VerificationFlags) === null || _addressResponse$Veri3 === void 0 ? void 0 : _addressResponse$Veri3.VerifyLevel) !== 'Verified' && (addressResponse === null || addressResponse === void 0 || (_addressResponse$Veri4 = addressResponse.VerificationFlags) === null || _addressResponse$Veri4 === void 0 ? void 0 : _addressResponse$Veri4.VerifyLevel) !== 'InteractionRequired') {
          setShowCustomAddressModal(true);
        } else {
          formik.setFieldValue('addressFinalized', formik.values.addressFinalized + 1);
        }
      }
    }, [formik.values.addressResponse]);

    // Trigger Id verfication call once address is finalzied
    (0, _react.useEffect)(() => {
      function postIdVerification(_x2) {
        return _postIdVerification.apply(this, arguments);
      }
      function _postIdVerification() {
        _postIdVerification = _asyncToGenerator(function* (payload) {
          try {
            var response = yield _axios.default.post('/apicalls/ccpa/identity/verify', payload);
            formik.setFieldValue('identityResponse', response.data);
          } catch (err) {
            setShowErrorAlert(true);
            setIsLoading(false);
          }
        });
        return _postIdVerification.apply(this, arguments);
      }
      ;
      if (formik.values.addressFinalized) {
        var payload = (0, _helper.generatePayload)(formik.values, true);
        postIdVerification(payload);
      }
    }, [formik.values.addressFinalized]);

    // Triggered when a new verifcation status is recieved, if it is 'ESCALATE' or 'CHALLENGE' we will prompt user for questions
    // If it is 'VERIFIED' or 'NOT_VERIFIED' we will redirect to confirmation page, as the case has been submitted by the backend
    (0, _react.useEffect)(() => {
      var {
        identityResponse
      } = formik.values;
      if (identityResponse) {
        if (identityResponse.identityVerificationTypeCode === 'ESCALATE' || identityResponse.identityVerificationTypeCode === 'CHALLENGE') {
          // We already have questions in the state, prompt user for them
          setShowQuestionsModal(true);
          var timeoutInterval = identityResponse.identityVerificationTypeCode === 'ESCALATE' ? _data.escalateTimeoutInterval : _data.challengeTimeoutInterval;
          /* istanbul ignore next */
          var timeoutIdHolder = setTimeout(() => {
            formik.setFieldValue('timeout', formik.values.timeout + 1);
          }, timeoutInterval);
          // Set timeoutId so that we can cancel the timeout if the user responds in time
          setTimeoutId(timeoutIdHolder);
        } else {
          var {
            linkUrl
          } = (0, _linkFieldSrc.linkFieldSrc)(extractFields.ConfirmationPage.value);
          window.location.href = linkUrl;
        }
      }
    }, [formik.values.identityResponse]);

    // Call KBA Submit after all questions are answered, update identityResponse with result (trigger other useEffect)
    // This useEffect has two different scenaris based on identityVerificationTypeCode
    (0, _react.useEffect)(() => {
      function postKbaSubmit(_x3) {
        return _postKbaSubmit.apply(this, arguments);
      }
      function _postKbaSubmit() {
        _postKbaSubmit = _asyncToGenerator(function* (payload) {
          var isChallenge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          try {
            var response = yield _axios.default.post("/apicalls/ccpa/identity/".concat(isChallenge ? 'challenge' : 'kba'), payload);
            formik.setFieldValue('identityResponse', response.data);
          } catch (err) {
            setShowErrorAlert(true);
            setIsLoading(false);
          }
        });
        return _postKbaSubmit.apply(this, arguments);
      }
      ;
      if (formik.values.kbaSubmit) {
        var _formik$values, _formik$values2;
        // Clear previously created timeout if it exists
        if (timeoutId) {
          clearTimeout(timeoutId);
          setTimeoutId('');
        }
        // idNumber is in different location based on structure of the identityResponse
        var idNumber = formik.values.identityResponse.identityVerificationTypeCode === 'ESCALATE' ? (_formik$values = formik.values) === null || _formik$values === void 0 || (_formik$values = _formik$values.identityResponse) === null || _formik$values === void 0 || (_formik$values = _formik$values.kba) === null || _formik$values === void 0 ? void 0 : _formik$values.idNumber : (_formik$values2 = formik.values) === null || _formik$values2 === void 0 || (_formik$values2 = _formik$values2.identityResponse) === null || _formik$values2 === void 0 || (_formik$values2 = _formik$values2.challenge) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.idNumber;

        // construct payload
        var payload = (0, _helper.generatePayload)(formik.values, true);
        var answerKeyString = formik.values.identityResponse.identityVerificationTypeCode === 'ESCALATE' ? 'kba' : 'challenge';
        payload[answerKeyString] = {
          idNumber: idNumber,
          answers: formik.values.answers
        };

        // if it is 'CHALLENGE scenario then call the api function with true as second param to modify route
        if (formik.values.identityResponse.identityVerificationTypeCode === 'ESCALATE') {
          postKbaSubmit(payload);
        } else if (formik.values.identityResponse.identityVerificationTypeCode === 'CHALLENGE') {
          postKbaSubmit(payload, true);
        }

        // reset answers and kbaIndex, in case we have challenge questions
        formik.setFieldValue('answers', {});
        formik.setFieldValue('kbaIndex', 0);
      }
    }, [formik.values.kbaSubmit]);
    // In the event of a modal timeout, show the popup and reset popup related fields
    /* istanbul ignore next */
    (0, _react.useEffect)(() => {
      if (formik.values.timeout) {
        setShowTimeoutModal(true);
        setShowQuestionsModal(false);
        formik.setFieldValue('answers', {});
        formik.setFieldValue('kbaIndex', 0);
      }
    }, [formik.values.timeout]);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "* = Required"), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: formik.handleSubmit,
      noValidate: true
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.firstName
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.lastName
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.dob
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.email
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.phoneNumber
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.residentialAddress
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.city
    }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
      className: "col-lg-4 col-sm-12 form-group"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
      label: "ccpa-state"
    }, "State*"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DropdownSelect, {
      data: ['CA'],
      defaultLabel: "CA",
      id: "ccpa-state",
      label: "State",
      required: true
    })), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      formik: formik,
      config: _data.componentConfig.zipCode
    }), /*#__PURE__*/_react.default.createElement(_CheckboxGroup.RelationshipToMM, {
      formik: formik
    }), /*#__PURE__*/_react.default.createElement(_CheckboxGroup.RequestCategory, {
      formik: formik
    }), formik.values.requestToCorrect ? /*#__PURE__*/_react.default.createElement(_TextArea.default, {
      formik: formik,
      customContent: /*#__PURE__*/_react.default.createElement(_RequestToCorrectContent.default, null),
      config: _data.componentConfig.requestToCorrectText
    }) : '', showErrorAlert ? /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Alert, {
      dismissible: true,
      style: {
        width: '100%'
      },
      type: "danger",
      onClose: () => setShowErrorAlert(false)
    }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("p", null, "Something went wrong.")), /*#__PURE__*/_react.default.createElement("p", null, "The request was not submitted. Please try again in a moment.")) : '', /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
      className: isLoading ? 'btn-primary-loading mm-spacing--minor' : 'mm-spacing--minor',
      disabled: isLoading,
      onMouseDown: event => {
        event.preventDefault();
      },
      type: "submit"
    }, isLoading ? '' : 'Submit'), /*#__PURE__*/_react.default.createElement("p", {
      className: "copy-sm mm-spacing--minor"
    }, "By submitting the form, I consent to MassMutual and its service providers using my information for the purpose of communicating with me and managing my rights request(s)."))), /*#__PURE__*/_react.default.createElement(_Popup.default, {
      show: showCorrectionModal,
      content: /*#__PURE__*/_react.default.createElement(_AddressCorrection.default, {
        data: {
          street: (_formik$values3 = formik.values) === null || _formik$values3 === void 0 || (_formik$values3 = _formik$values3.addressResponse) === null || _formik$values3 === void 0 || (_formik$values3 = _formik$values3.Address) === null || _formik$values3 === void 0 ? void 0 : _formik$values3.Street1,
          city: (_formik$values4 = formik.values) === null || _formik$values4 === void 0 || (_formik$values4 = _formik$values4.addressResponse) === null || _formik$values4 === void 0 || (_formik$values4 = _formik$values4.Address) === null || _formik$values4 === void 0 ? void 0 : _formik$values4.City,
          state: (_formik$values5 = formik.values) === null || _formik$values5 === void 0 || (_formik$values5 = _formik$values5.addressResponse) === null || _formik$values5 === void 0 || (_formik$values5 = _formik$values5.Address) === null || _formik$values5 === void 0 ? void 0 : _formik$values5.State,
          zip: (_formik$values6 = formik.values) === null || _formik$values6 === void 0 || (_formik$values6 = _formik$values6.addressResponse) === null || _formik$values6 === void 0 || (_formik$values6 = _formik$values6.Address) === null || _formik$values6 === void 0 ? void 0 : _formik$values6.Zip
        },
        submit: () => {
          var _formik$values7, _formik$values8, _formik$values9, _formik$values0;
          formik.setFieldValue('residentialAddress', (_formik$values7 = formik.values) === null || _formik$values7 === void 0 || (_formik$values7 = _formik$values7.addressResponse) === null || _formik$values7 === void 0 || (_formik$values7 = _formik$values7.Address) === null || _formik$values7 === void 0 ? void 0 : _formik$values7.Street1);
          formik.setFieldValue('city', (_formik$values8 = formik.values) === null || _formik$values8 === void 0 || (_formik$values8 = _formik$values8.addressResponse) === null || _formik$values8 === void 0 || (_formik$values8 = _formik$values8.Address) === null || _formik$values8 === void 0 ? void 0 : _formik$values8.City);
          formik.setFieldValue('state', (_formik$values9 = formik.values) === null || _formik$values9 === void 0 || (_formik$values9 = _formik$values9.addressResponse) === null || _formik$values9 === void 0 || (_formik$values9 = _formik$values9.Address) === null || _formik$values9 === void 0 ? void 0 : _formik$values9.State);
          formik.setFieldValue('zipCode', (_formik$values0 = formik.values) === null || _formik$values0 === void 0 || (_formik$values0 = _formik$values0.addressResponse) === null || _formik$values0 === void 0 || (_formik$values0 = _formik$values0.Address) === null || _formik$values0 === void 0 ? void 0 : _formik$values0.Zip);
          formik.setFieldValue('addressFinalized', formik.values.addressFinalized + 1);
          setShowCorrectionModal(false);
        },
        cancel: () => {
          formik.setFieldValue('addressFinalized', formik.values.addressFinalized + 1);
          setShowCorrectionModal(false);
        }
      }),
      handleClose: () => {
        setShowCorrectionModal(false);
        setIsLoading(false);
      },
      title: "The following USPS address was found. Would you like to use this address?"
    }), /*#__PURE__*/_react.default.createElement(_Popup.default, {
      show: showCustomAddressModal,
      handleClose: () => {
        setShowCustomAddressModal(false);
        setIsLoading(false);
      },
      content: /*#__PURE__*/_react.default.createElement(_CustomAddress.default, {
        submit: () => {
          formik.setFieldValue('addressFinalized', formik.values.addressFinalized + 1);
          setShowCustomAddressModal(false);
        },
        cancel: () => {
          setShowCustomAddressModal(false);
          setIsLoading(false);
        }
      }),
      title: "USPS address not found. Would you like to continue?"
    }), /*#__PURE__*/_react.default.createElement(_Popup.default, {
      show: showTimeoutModal,
      handleClose: () => {
        setShowTimeoutModal(false);
        setIsLoading(false);
        // If they close the modal for KBA, we need to cancel the 
        if (timeoutId) {
          clearTimeout(timeoutId);
          setTimeoutId('');
        }
      },
      content: /*#__PURE__*/_react.default.createElement(_Timeout.default, {
        submit: () => {
          setShowTimeoutModal(false);
          setIsLoading(false);
        }
      }),
      title: "Session timed out."
    }), showQuestionsModal && /*#__PURE__*/_react.default.createElement(_Popup.default, {
      show: showQuestionsModal,
      handleClose: () => {
        setShowQuestionsModal(false);
        setIsLoading(false);
      },
      content: /*#__PURE__*/_react.default.createElement(_Questions.default, {
        formik: formik,
        setShowQuestionsModal: setShowQuestionsModal
      }),
      title: "We need to verify your identity"
    }));
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 12,
    lg: 5
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, (0, _richTextField.parseHTML)(extractFields.SideContent))));
};
var _default = exports.default = CCPAForm;